
import React, { Component, PropTypes } from 'react';
import Translate from '../layout/Translate';

import DatePicker from 'react-datepicker';
var moment = require('moment');

export default class Client extends Component {


    saveClient(client, i, e) {
       //console.log(this.props.order);
        this.props.actions.fetchSaveClientIfNeeded(this.props.order.id, client, i);

    }

    changeClient(i, key, e) {
       //console.log(e);
        //console.log(e);
        //console.log(e.target);
        if (e.target && e.target.type === 'checkbox') {
            this.props.actions.changeClient(i, key, (e.target.checked)?1:0);
        } else {
            this.props.actions.changeClient(i, key, (e.target)?e.target.value:e);
        }
    }

    componentDidUpdate () {
        let actions = this.props.actions;



        if (this.props.order.client.promise) {

           //console.log(this.props.order.client.promise);
           //console.log(this.props.order.client.promise);

            this.props.order.client.promise.json().then(function (result) {
                actions.setClient(result);
            });
        }
    }

    componentWillUpdate () {
        let actions = this.props.actions;

       //console.log(typeof this.props.client.passport_issued_date);

    }

    render () {
        const order = this.props.order;
        let client = this.props.client;
        const i = this.props.i;



        if (typeof client.passport_issued_date == 'number') {
            client.passport_issued_date = moment(client.passport_issued_date * 1000);
        } else if (typeof client.passport_issued_date == 'string') {
            client.passport_issued_date = moment(parseInt(client.passport_issued_date) * 1000);
        }
        if (typeof client.date_of_birth == 'number') {
            client.date_of_birth = moment(client.date_of_birth * 1000);
        } else if (typeof client.date_of_birth == 'string') {
            client.date_of_birth = moment(parseInt(client.date_of_birth) * 1000);
        }
        if (typeof client.passport_expiration_date == 'number') {
            client.passport_expiration_date = moment(client.passport_expiration_date * 1000);
        } else if (typeof client.passport_expiration_date == 'string') {
            client.passport_expiration_date = moment(parseInt(client.passport_expiration_date) * 1000);
        }

        //console.log('client');
        //console.log(client);

        return (

                        <tbody>
                            <tr className=" services__row">
                                <td className=" services__col"></td>
                                <td className=" services__col">
                                    <span className="services__title">
                                        <Translate slug="order__client__number" /> {i+1}
                                        {!!client.id &&
                                            <span>({client.id})</span>
                                        }
                                    </span>
                                </td>


                                <td className=" services__col">
                                    <div className="services__status"><Translate slug="order__client__status_no" /></div>
                                    <div className="services__status services__status_ok"><Translate slug="order__client__status_ok" /></div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="3" className="">
                                    <div className="form__row">

                                        <div className="form__col form__col">
                                            <label className="form__label">
                                                <Translate slug="order__client__lang" />
                                            </label>
                                            <select className="form__select form__control">
                                                <option>Русский</option>
                                            </select>
                                        </div>
                                        <div className="form__col form__col">
                                            <label className="form__label">
                                                <Translate slug="order__client__country" />
                                            </label>
                                            <select className="form__select form__control">
                                                <option>Россия</option>
                                            </select>
                                        </div>
                                        <div className="form__col form__col">
                                            <label className="form__label">
                                                <Translate slug="order__client__sex" />
                                            </label>
                                            <select className="form__select form__control">
                                                <option><Translate slug="order__client__male" /></option>
                                                <option><Translate slug="order__client__female" /></option>
                                            </select>
                                        </div>
                                        <div className="form__col form__col">
                                            <label className="form__label">
                                                <Translate slug="order__client__birth-date" />
                                            </label>
                                            <label className="form__label_picker">
                                                <DatePicker
                                                    selected={client.date_of_birth}
                                                    onChange={this.changeClient.bind(this, i, 'date_of_birth')}
                                                    className="form__control form__input form__input_datepicker"
                                                    forceShowMonthNavigation={true}
                                                    showYearDropdown={true}
                                                    showMonthDropdown={true}
                                                    dropdownMode={'select'}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form__row">
                                        <div className="form__col form__col_6">
                                            <label className="form__label">
                                                <Translate slug="order__client__first-name" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.first_name} onChange={this.changeClient.bind(this, i, 'first_name')} />
                                        </div>
                                        <div className="form__col form__col_6">
                                            <label className="form__label">
                                                <Translate slug="order__client__last-name" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.last_name} onChange={this.changeClient.bind(this, i, 'last_name')}/>
                                        </div>
                                    </div>
                                    <div className="form__row">
                                        <div className="form__col form__col_6">
                                            <label className="form__label">
                                                <Translate slug="order__client__pasport-number" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.passport_number} onChange={this.changeClient.bind(this, i, 'passport_number')} />
                                        </div>
                                        <div className="form__col form__col_3">
                                            <label className="form__label">
                                                <Translate slug="order__client__pasport-start-date" />
                                            </label>
                                            <label className="form__label_picker">
                                                <DatePicker
                                                    selected={client.passport_issued_date}
                                                    onChange={this.changeClient.bind(this, i, 'passport_issued_date')}
                                                    className="form__control form__input form__input_datepicker"
                                                    forceShowMonthNavigation={true}
                                                    showYearDropdown={true}
                                                    showMonthDropdown={true}
                                                    dropdownMode={'select'}
                                                />
                                            </label>

                                        </div>
                                        <div className="form__col form__col_3">
                                            <label className="form__label">
                                                <Translate slug="order__client__pasport-end-date" />
                                            </label>
                                            <label className="form__label_picker">
                                                <DatePicker
                                                    selected={client.passport_expiration_date}
                                                    onChange={this.changeClient.bind(this, i, 'passport_expiration_date')}
                                                    className="form__control form__input form__input_datepicker"
                                                    forceShowMonthNavigation={true}
                                                    showYearDropdown={true}
                                                    showMonthDropdown={true}
                                                    dropdownMode={'select'}
                                                />
                                            </label>

                                        </div>
                                    </div>
                                    <div className="form__row">

                                        <div className="form__col form__col_6">
                                            <label className="form__label">
                                                <Translate slug="order__client__email" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.email} onChange={this.changeClient.bind(this, i, 'email')}/>
                                        </div>
                                    </div>
                                    <div className="form__row">

                                        <div className="form__col form__col_6">
                                            <label className="form__label">
                                                <Translate slug="order__client__phone" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.phone} onChange={this.changeClient.bind(this, i, 'phone')}/>
                                        </div>
                                    </div>
                                    <div className="form__row">

                                        <div className="form__col form__col_3">
                                            <label className="form__label">
                                                <Translate slug="order__client__post" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.postal_code} onChange={this.changeClient.bind(this, i, 'postal_code')}/>
                                        </div>
                                        <div className="form__col form__col_3">
                                            <label className="form__label">
                                                <Translate slug="order__client__city" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.city} onChange={this.changeClient.bind(this, i, 'city')}/>
                                        </div>
                                        <div className="form__col form__col_6">
                                            <label className="form__label">
                                                <Translate slug="order__client__address" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.address} onChange={this.changeClient.bind(this, i, 'address')}/>
                                        </div>
                                    </div>
                                    <div className="form__row">

                                        <div className="form__col form__col_3">
                                            <label className="form__label">
                                                <Translate slug="order__client__insurance-number" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.insurance_number} onChange={this.changeClient.bind(this, i, 'insurance_number')}/>
                                        </div>
                                        <div className="form__col form__col_9">
                                            <label className="form__label">
                                                <Translate slug="order__client__insurance-company" />
                                            </label>
                                            <input type="text" className="form__control form__input" value={client.insurance_company_info} onChange={this.changeClient.bind(this, i, 'insurance_company_info')}/>
                                        </div>
                                    </div>

                                    <div className="form__section">
                                        <div className="form__subtitle form__label">
                                            <Translate slug="order__client__health" />
                                        </div>

                                        <div className="form__row">

                                            <div className="form__col form__col_12">
                                                <label className="form__label form__label_inline form__label_checkbox">
                                                    <input className="checkbox" type="checkbox" value={1} checked={client.health_diabet} onChange={this.changeClient.bind(this, i, 'health_diabet')} />
                                                    <Translate slug="order__client__diabet" />
                                                </label>
                                                <label className="form__label form__label_inline form__label_checkbox">
                                                    <input className="checkbox" type="checkbox" value={1} checked={client.health_allergic} onChange={this.changeClient.bind(this, i, 'health_allergic')} />
                                                    <Translate slug="order__client__allergic" />
                                                </label>
                                                <label className="form__label form__label_inline form__label_checkbox">
                                                    <input className="checkbox" type="checkbox" value={1} checked={client.health_vegetarian} onChange={this.changeClient.bind(this, i, 'health_vegetarian')} />
                                                    <Translate slug="order__client__vegetarian" />
                                                </label>
                                                <label className="form__label form__label_inline form__label_checkbox">
                                                    <input className="checkbox" type="checkbox" value={1} checked={client.health_cholesterol} onChange={this.changeClient.bind(this, i, 'health_cholesterol')} />
                                                    <Translate slug="order__client__cholesterol" />
                                                </label>
                                            </div>

                                        </div>
                                        <div className="form__row">

                                            <div className="form__col form__col_12">
                                                <label className="form__label">
                                                    <Translate slug="order__client__cholesterol" />
                                                </label>
                                                <textarea className="form__control form__input" value={client.health_other} onChange={this.changeClient.bind(this, i, 'health_other')}></textarea>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="form__section">
                                        <div className="form__subtitle form__label">
                                            <Translate slug="order__client__contact-type" />
                                        </div>
                                        <div className="form__row">

                                            <div className="form__col form__col_6">
                                                <label className="form__label">
                                                    <Translate slug="order__client__contact-name" />
                                                </label>
                                                <input type="text" className="form__control form__input" value={client.urgent_contact_name} onChange={this.changeClient.bind(this, i, 'urgent_contact_name')}/>
                                            </div>
                                            <div className="form__col form__col_6">
                                                <label className="form__label">
                                                    <Translate slug="order__client__contact-phone" />
                                                </label>
                                                <input type="text" className="form__control form__input" value={client.urgent_contact_phone} onChange={this.changeClient.bind(this, i, 'urgent_contact_phone')}/>
                                            </div>
                                        </div>

                                        <div className="form__row">
                                            <div className="form__col form__col_comment">
                                                <Translate slug="order__client__contact-comment" />
                                            </div>
                                        </div>

                                    </div>

                                    <div className="form__row">
                                        <div className="form__col">
                                            <button className="form__button form__button_success" onClick={this.saveClient.bind(this, client, i)}>
                                                <Translate slug="order__client__save" />
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                        </tbody>

        );
    }
}














// WEBPACK FOOTER //
// ./src/common/components/order/Client.js